export default __webpack_public_path__ + "static/media/japantrad9.c7ea3aa7.png";